"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/YTFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_254)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_254`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M24.24 15.84C23.8 16.12 24.24 16.56 24 16.6C23.76 16.64 23.4 16.04 23.92 15.6C24.56 15 26.24 15.6 26.28 17.32C26.28 18.2 25.92 20.04 23.4 20.04C20.36 20.04 18.84 17.76 18.84 15.48C18.84 13.56 20.32 10.08 21.44 9.64002C22.68 9.16002 24.12 8.24002 24.16 7.64002C24.16 7.44002 23.6 7.60002 22.84 8.00002C21.6 8.68002 20.2 9.00002 20.2 8.56002C20.2 8.12002 21.36 7.32002 21.8 6.72002C22.28 6.08002 22.16 4.52002 23 4.52002C26.04 4.52002 26.96 7.60002 25.8 9.20002C25.04 10.24 27.52 9.60002 27.52 9.60002C27.52 9.60002 27.52 11.72 26.24 12.52C25.04 13.24 24.32 14.08 24.32 14.08C24.32 14.08 24.4 12.24 24.12 12.52C23.88 12.8 19.68 14.32 20 17.32C20.12 18.52 21.8 19.48 23.4 19.4C25 19.32 25.68 18.44 25.72 17.44C25.76 15.88 24.52 15.68 24.24 15.84ZM-1.71999 17.44C-1.67999 18.44 -0.999989 19.32 0.600011 19.4C2.20001 19.48 3.88001 18.52 4.00001 17.32C4.32001 14.32 0.120011 12.8 -0.119989 12.52C-0.399989 12.24 -0.319989 14.08 -0.319989 14.08C-0.319989 14.08 -1.03999 13.24 -2.23999 12.52C-3.51999 11.72 -3.51999 9.60002 -3.51999 9.60002C-3.51999 9.60002 -1.03999 10.24 -1.79999 9.20002C-2.95999 7.60002 -2.03999 4.52002 1.00001 4.52002C1.84001 4.52002 1.72001 6.08002 2.20001 6.72002C2.64001 7.32002 3.80001 8.12002 3.80001 8.56002C3.80001 9.00002 2.40001 8.68002 1.16001 8.00002C0.400011 7.60002 -0.159989 7.44002 -0.159989 7.64002C-0.119989 8.24002 1.32001 9.16002 2.56001 9.64002C3.68001 10.08 5.16001 13.56 5.16001 15.48C5.16001 17.76 3.64001 20.04 0.600011 20.04C-1.91999 20.04 -2.27999 18.2 -2.27999 17.32C-2.23999 15.6 -0.559989 15 0.0800111 15.6C0.560011 16.04 0.240011 16.68 1.12057e-05 16.6C-0.239989 16.56 0.240011 16.12 -0.239989 15.84C-0.479989 15.68 -1.71999 15.88 -1.71999 17.44Z",
					fill: "#ABABAB",
					stroke: "#7F7F7F",
					strokeWidth: .1
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.40002 11.52V17.12C6.40002 17.88 7.24002 17.76 7.24002 17.76H10.96C11.44 17.76 12 18.68 12 18.68C12 18.68 12.56 17.76 13 17.76H16.84C16.84 17.76 17.64 17.84 17.64 17.04V11.48H6.40002V11.52Z",
					fill: "#DE393A"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.40002 5.23999H17.6V11.52H6.40002V5.23999Z",
					fill: "#3951A3"
				}),
				/* @__PURE__ */ n("path", {
					d: "M14.04 6.59998C13.88 7.55998 13.04 8.27998 12 8.27998C11 8.27998 10.16 7.55998 9.96002 6.59998C9.76002 6.95998 9.64001 7.35998 9.64001 7.79998C9.64001 9.11998 10.68 10.16 12 10.16C13.32 10.16 14.36 9.11998 14.36 7.79998C14.36 7.35998 14.24 6.95998 14.04 6.59998Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.64 15.8C10.3027 15.8 10.84 15.2628 10.84 14.6C10.84 13.9373 10.3027 13.4 9.64 13.4C8.97726 13.4 8.44 13.9373 8.44 14.6C8.44 15.2628 8.97726 15.8 9.64 15.8Z",
					fill: "#FEE05F"
				}),
				/* @__PURE__ */ n("path", {
					d: "M14.36 15.8C15.0227 15.8 15.56 15.2628 15.56 14.6C15.56 13.9373 15.0227 13.4 14.36 13.4C13.6972 13.4 13.16 13.9373 13.16 14.6C13.16 15.2628 13.6972 15.8 14.36 15.8Z",
					fill: "#FEE05F"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_254`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as YTFlag };
